import { Actions } from '@ngrx/effects';
import { AppState } from '@_store/index.reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyCommunicationGeneratedDocumentApiService } from '@_services/api/company-communication-generated-document-api.service';
import { GeneratedCompanyCommunicationGeneratedDocumentEffects } from './company-communication-generated-document-generated.effects';

@Injectable()
export class CompanyCommunicationGeneratedDocumentEffects extends GeneratedCompanyCommunicationGeneratedDocumentEffects {
  constructor(
    actions$: Actions,
    companyCommunicationGeneratedDocumentApiService: CompanyCommunicationGeneratedDocumentApiService,
    store$: Store<AppState>
  ) {
    super(actions$, companyCommunicationGeneratedDocumentApiService, store$);
  }
}
